export default "__VITE_ASSET__D03YgPY9__"